module.exports = __webpack_public_path__ + "img/file-others.444e08ac.svg";